<template>
    <div class="JournalismPage">
        <div class="main">
            <p class="modular_title animate__animated animate__fadeInLeftBig wow">精选资讯</p>
            <p class="modular_title_en animate__animated animate__fadeInLeftBig wow">Select Consultation Know in Advance</p>
            <a-row :gutter="[20, 20]" style="margin-top: 20px;">
                <a-col :xs="24" :sm="24" :md="24" :lg="8" v-for="item,index in list" :key="index">
                    <div class="zx_list_box" >
                        <div class="zx_list_box">
                            <div class="blog-image">
                                <img :src="item.cmsCover_url ? item.cmsCover_url : '../../assets/imgs/shapes/about-1.jpg'" class="zx_list_img" alt="" />
                            </div>
                            <div class="blog-content">
                                <div class="post-meta">
                                    <span class="p-relative"><i class="iconfont">&#xe60d;</i>{{ item.createBy }}</span>
                                    <span class="p-relative"><i class="iconfont">&#xe683;</i>{{ item.createTime }}</span>
                                </div>
                                <hr />
                                <h5 class="blog-title mb-30">
                                    <a href="blog-details.html">{{ item.cmsDesc }}</a>
                                </h5>
                                <div class="blog-link">
                                    <a class="primary-btn-5 btn-hover" href="blog-details.html">
                                        查看更多 &nbsp; | <i class="iconfont">&#xe60e;</i>
                                        <span style="top: 147.172px; left: 108.5px"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </a-col>
            </a-row>
        </div>
    </div>
</template>
<script>
import { getAction } from "@/api/manage";
export default {
    name: "",
    components: {},
    data() {
        return {
            list:[]
        };
    },
    created() { this.init()},
    mounted() { },
    methods: {
        init(){
            getAction("/teaching/teachingCms/getCmsList", {
                cmsStatus: '',
                cmsType: '',
                pageNo:1,
                pageSize: 3,
            }).then((res) => {
                if (res.success) {
                this.list = res.result.records;
                }
            });
        }
    },
};
</script>
<style lang='less' scoped>
.JournalismPage {
    width: 100%;
    background: #fff;
    height: auto;
    padding: 40px 0;

    .main {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;

        .zx_list_box {
            width: 100%;
        }

        .zx_list_img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .blog-title {
            min-height: 50px;
            font-size: 22px;
            color: black;
        }

        .blog-title-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .zx_list_box .blog-content {
            background: #fff;
            box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.08);
            padding: 30px;
        }

        .zx_list_box .post-meta span {
            font-size: 14px;
        }

        .zx_list_box .post-meta span:hover {
            color: var(--primary-color);
        }

        .zx_list_box .post-meta span i {
            color: var(--primary-color);
            margin-right: 8px;
        }

        .zx_list_box .post-meta {
            display: inline-flex;
            gap: 26px;
        }

        .zx_list_box hr {
            margin: 15px 0;
        }

        .zx_list_box .blog-content .blog-title:hover {
            color: var(--primary-color);
        }

        /* shine start */
        .zx_list_box .blog-image {
            position: relative;
            display: block;
            overflow: hidden;
            height: 254px;
        }

        .zx_list_box .blog-image:before {
            position: absolute;
            top: 0;
            left: -75%;
            display: block;
            content: "";
            width: 50%;
            height: 100%;
            background: -o-linear-gradient(left,
                    rgba(255, 255, 255, 0) 0%,
                    rgba(255, 255, 255, 0.3) 100%);
            background: -webkit-gradient(linear,
                    left top,
                    right top,
                    from(rgba(255, 255, 255, 0)),
                    to(rgba(255, 255, 255, 0.3)));
            background: linear-gradient(to right,
                    rgba(255, 255, 255, 0) 0%,
                    rgba(255, 255, 255, 0.3) 100%);
            -webkit-transform: skewX(-25deg);
            -ms-transform: skewX(-25deg);
            transform: skewX(-25deg);
        }

        .zx_list_box:hover .blog-image:before {
            animation: shine 1.5s;
        }

        /* shine end */

        @-webkit-keyframes shine {
            100% {
                left: 125%;
            }
        }

        @keyframes shine {
            100% {
                left: 125%;
            }
        }
    }

    .primary-btn-5 {
        color: var(--primary-color);
        font-size: 14px;
        font-weight: 500;
        background-color: #fff;
        border: 1px solid #ececec;
        display: inline-flex;
        align-items: center;
        line-height: normal;
        white-space: nowrap;
        padding: 15px 20px;
        gap: 10px;
        overflow: hidden;
        position: relative;
        z-index: 1;
        text-transform: uppercase;
        transition: all 0.6s;
    }

    .primary-btn-5 span {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-radius: 50%;
        background-color: var(--primary-color);
        transition: all 0.6s;
        transform: translate(-50%, -50%);
        z-index: -1;
    }

    .primary-btn-5:hover {
        color: #fff;
        border: 1px solid var(--primary-color);
    }

    .primary-btn-5:hover span {
        width: 225%;
        height: 1000.5px;
    }

    .primary-btn-5:active {
        background-color: #fff;
    }
}
</style>
